module.exports = __webpack_public_path__ + "img/profile-placeholder-image-png.78941f1c.png";